import { render, staticRenderFns } from "./ItemWebOptions.vue?vue&type=template&id=0af96489&scoped=true"
import script from "./ItemWebOptions.vue?vue&type=script&lang=js"
export * from "./ItemWebOptions.vue?vue&type=script&lang=js"
import style0 from "./ItemWebOptions.vue?vue&type=style&index=0&id=0af96489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af96489",
  null
  
)

export default component.exports